import { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaPlus, FaMinus } from "react-icons/fa";
import classes from "./Section4.module.css";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "What products and services does Prime Cloud Systems provide?",
    a: "High-performance IT hardware and networking equipment for home users, IT professionals, and businesses—new and certified refurbished.",
  },
  {
    q: "Do you supply refurbished and end-of-life IT hardware?",
    a: "Yes. We specialize in certified refurbished and end-of-life IT hardware from trusted brands like HPE, Dell, and IBM, helping businesses and individuals reduce costs without compromising on quality or reliability.",
  },
  {
    q: "How does Prime Cloud Systems ensure data security?",
    a: "We follow industry-standard data protection practices to ensure the secure handling and disposal of storage devices. This includes certified data wiping and proper processing of sensitive hardware, protecting your information and maintaining compliance.",
  },
  {
    q: "Can Prime Cloud Systems help reduce IT infrastructure costs?",
    a: "Absolutely. Our solutions, including optimized sourcing, refurbishment, and lifecycle extension strategies, allow organizations and individuals to save on IT costs while maintaining high-performance hardware.",
  },
  {
    q: "Do you provide nationwide support and fast shipping?",
    a: "Yes. Prime Cloud Systems provides fast shipping across the USA, along with expert guidance and support for all IT hardware, networking setups, and technical queries to ensure smooth operations.",
  },
];

export default function Section4() {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className={classes.section4Wrapper}>
      <div className={classes.section4Content}>
        {/* LEFT SIDE */}
        <div className={classes.left}>
          <div className={classes.highLightedText}>
            <span>FAQs</span>
          </div>

          <h2 className={classes.title}>
            Frequently Asked Questions About Prime Cloud Systems
          </h2>

          <p className={classes.description}>
            Find answers to the most common questions about our IT hardware,
            networking solutions, refurbished equipment, data security
            practices, and nationwide support. Learn how Prime Cloud Systems
            provides reliable, high-performance, and cost-effective technology
            solutions for home users, IT professionals, and businesses across
            the USA.
          </p>

          {/* CTA AREA */}
          <div className={classes.callBox}>
            <div className={classes.callIcon}>
              <FaPhoneAlt />
            </div>
            <div className={classes.callText}>
              <span>Call Us</span>
              <strong>
                <Link to={"tel:+18444211258"}>1-844-421-1258</Link>
              </strong>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE - FAQ */}
        <div className={classes.right}>
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`${classes.faqItem} ${
                activeIndex === index ? classes.active : ""
              }`}
            >
              <button
                className={classes.faqQuestion}
                onClick={() => toggleFAQ(index)}
                aria-expanded={activeIndex === index}
              >
                <h4>{faq.q}</h4>
                <span className={classes.icon}>
                  {activeIndex === index ? <FaMinus /> : <FaPlus />}
                </span>
              </button>

              <div className={classes.faqAnswer}>
                <p>{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
